import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import DatePicker from 'react-datepicker';
const Moment = require('moment');
import { Row, Button } from 'react-bootstrap';
const isArray = require('lodash/isArray');

const Strings = require('../../../../app/shared/Strings');
const ChannelStore = require('../../stores/channel_store_reflux');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
import TimeseriesChart from '../chart/TimeseriesChart';
import { ChartTotalsBoxRow, ChartTotalsBox, ChartTotalsBoxItem } from '../chart/ChartTotalsBox';

const propTypes = {
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    className: PropTypes.string
};

const defaultProps = {
    className: ""
};

class ChannelActivityOverviewRangeChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getStateChannel(props.channelId),
            analyticsStoreState: AnalyticsStore.getState(),
            startDate: Moment().subtract(1, 'M').toDate(),
            endDate: new Date(),
            overviewAnalyticsRangeActionId: null
        };

        this.getAnalytics = this.getAnalytics.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onOverviewRangeUpdate = this.onOverviewRangeUpdate.bind(this);

        this.unsubscribes = [
            AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this))
        ];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activityId !== this.props.activityId) {
            const activityStats = this.state.analyticsStoreState.channelActivityOverviewRange[this.props.activityId];
            if (!!activityStats && isArray(activityStats.timeseriesCol) && activityStats.timeseriesCol.length > 0) {
                this.setState({
                    startDate: Moment(activityStats.timeseriesCol[1]).toDate(),
                    endDate: Moment(activityStats.timeseriesCol[activityStats.timeseriesCol.length-1]).toDate(),
                });
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getAnalytics(channelId, activityId) {
        const overviewAnalyticsRangeActionId = uuid.v4();
        this.setState({ overviewAnalyticsRangeActionId: overviewAnalyticsRangeActionId }, () => {
            AnalyticsActions.getChannelActivityOverviewRange(
                overviewAnalyticsRangeActionId,
                {
                    activityId: activityId,
                    channelId: channelId,
                    startDate: Moment(this.state.startDate),
                    endDate: Moment(this.state.endDate)
                }
            );
        });
    }

    onChannelStoreChange(state) {
        this.setState({
            channelStoreState: ChannelStore.getStateChannel(this.props.channelId),
        })
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.overviewAnalyticsRangeActionId) {
            additionalState.overviewAnalyticsRangeActionId = null;
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    onStartDateChange(date) {
        this.setState({ startDate: date });
    }

    onEndDateChange(date) {
        this.setState({ endDate: date });
    }

    onOverviewRangeUpdate(e) {
        this.getAnalytics(this.props.channelId, this.props.activityId);
    }

    render() {
        const activityStats = this.state.analyticsStoreState.channelActivityOverviewRange[this.props.activityId];
        if (!this.state.channelStoreState.initialized) {
            return (null);
        }

        const currentChannel = this.state.channelStoreState.channel;
        if (!currentChannel) {
            console.error(`ChannelActivityOverviewRangeChart: Channel ${this.props.channelId} not found in store.`);
            return null;
        }

        function _oar_total(arr) {
            var t=0;
            for (var i=1; i<arr.length; ++i) {
                t += arr[i];
            }
            return t;
        }

        return (
            <div className={`${this.props.className}`}>
                <Row className="margin-bottom-lg">
                    <div className="col-12 col-sm-5 margin-bottom-sm">
                        <label className="label-form margin-right-sm">
                            Start Date
                        </label>
                        <DatePicker
                            className="margin-right-md"
                            selected={this.state.startDate}
                            onChange={this.onStartDateChange}
                            minDate={Moment(currentChannel.created_at).toDate()}
                            maxDate={new Date()}
                        />
                    </div>
                    <div className="col-12 col-sm-5 margin-bottom-sm">
                        <label className="label-form margin-right-sm">
                            End Date
                        </label>
                        <DatePicker
                            className="margin-right-md"
                            selected={this.state.endDate}
                            onChange={this.onEndDateChange}
                            minDate={Moment(currentChannel.created_at).toDate()}
                            maxDate={new Date()
                        }/>
                    </div>
                    <div className="col-12 col-sm-2 margin-bottom-sm">
                        <Button
                            disabled={!!this.state.overviewAnalyticsRangeActionId}
                            onClick={this.onOverviewRangeUpdate}
                        >
                            Update
                        </Button>
                    </div>
                </Row>
                {(!!activityStats) ?
                    <div className="margin-bottom-lg">
                            <TimeseriesChart
                                id="activity-stats-range-chart"
                                height={300}
                                labelShow={false}
                                legendShow={true}
                                yInt={true}
                                columns={[activityStats.timeseriesCol, activityStats.assignmentsCol, activityStats.attemptsCol, activityStats.activeStudentsCol]}
                            />
                            <ChartTotalsBoxRow>
                                <ChartTotalsBox title="Totals" className="chart-totals-wide margin-bottom-lg">
                                    <ChartTotalsBoxItem label={activityStats.assignmentsCol[0]} value={_oar_total(activityStats.assignmentsCol)} />
                                    {(typeof activityStats.nonEmptyAssnCount === 'number') &&
                                        <ChartTotalsBoxItem label={Strings['en'].analytics.COUNT_NON_EMPTY_ASSN} value={activityStats.nonEmptyAssnCount} />
                                    }
                                    <ChartTotalsBoxItem label={activityStats.attemptsCol[0]} value={_oar_total(activityStats.attemptsCol)} />
                                    <ChartTotalsBoxItem label={activityStats.activeStudentsCol[0]} value={activityStats.activeStudentsTotal} />
                                </ChartTotalsBox>
                            </ChartTotalsBoxRow>
                    </div>
                    :
                    <div className="margin-bottom-xl font-style-italic text-center">
                        {Strings['en'].analytics.overview.assignment_stats.UPDATE_PROMPT}
                    </div>
                }
                </div>
        );
    }
}

ChannelActivityOverviewRangeChart.propTypes = propTypes;
ChannelActivityOverviewRangeChart.defaultProps = defaultProps;

export default ChannelActivityOverviewRangeChart;